import {
    ChangeDetectorRef,
    Component,
    HostListener,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChildren,
} from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { tap } from 'rxjs/operators';
import { DisplayOptions } from '../../../shared/interfaces/display-options';
import { NoDataActionType } from '../../../shared/interfaces/no-data';
import { CustomDashboardsOutletDirective } from '../../my-limegear-outlet.directive';
import { iTracks } from '../../interfaces/my-limegear.interface';
import { ComponentsOutletDirectiveService } from '../../services/component-outlet-directive.service';
import { CustomDashboardsService } from '../../services/my-limegear.service';

@Component({
    selector: 'corporate-dashboard',
    templateUrl: './corporate-dashboard.component.html',
    styleUrls: ['./corporate-dashboard.component.scss'],
})
export class CorporateDashboardComponent implements OnInit, OnDestroy {
    constructor(
        private cd: ChangeDetectorRef,
        private customDashboardsService: CustomDashboardsService,
        private componentsOutletDirectiveService: ComponentsOutletDirectiveService,
        private dragula: DragulaService
    ) {}
    @ViewChildren(CustomDashboardsOutletDirective)
    dashboardOutlet: QueryList<CustomDashboardsOutletDirective>;

    displayOptions: DisplayOptions[];
    hFilterJSON: string;
    action: NoDataActionType;
    routerUrl: string;
    tracks: iTracks[] = [];
    pageTitle = 'Corporate Dashboard';
    dashboard = 'corporate';

    ngOnInit(): void {
        this.customDashboardsService.destroyCharts();
        this.customDashboardsService.detectChange(
            '',
            [],
            false,
            false,
            NoDataActionType.pageStart,
            this.dashboard
        );

        this.applyDragableEvents();
        this.getDashboardCards();
    }

    applyDragableEvents() {
        //let hasEditPermission = this.customDashboardsService.hasEditPermission();
        this.dragula.drag().subscribe((item) => {});
        this.dragula.drop().subscribe((item) => {
            try {
                let track = this.tracks.find((track) => track.group === item.name);

                if (track && !this.customDashboardsService.hasEditPermission()) {
                    track.group = '';
                }

                let elementIdList = item.target.children;
                let dragedCardIdListInfo: object[] = [];
                let dragedCardIdList: string[] = [];
                for (let i = 0; i < elementIdList.length; i++) {
                    let elementId = elementIdList.item(i).id;
                    let cardId = elementId.split('___')[1];
                    dragedCardIdListInfo.push({
                        cardGroup: item.name,
                        cardId: cardId,
                        cardOrder: i + 1,
                    });

                    dragedCardIdList.push(cardId);
                }

                track.cardsIdArray = dragedCardIdList;
                this.customDashboardsService
                    .updateClientDasboardCards(this.dashboard, dragedCardIdListInfo)
                    .subscribe((success) => {});
            } catch (error) {
                throw new Error(error);
            }
        });
    }

    getDashboardCards() {
        this.customDashboardsService
            .getDasboardCardsByClient(this.dashboard)
            .pipe(
                tap((dashboardCards) => {
                    this.customDashboardsService.updateCorporateDashboardCardList(dashboardCards);
                })
            )
            .subscribe(() => {
                this.customDashboardsService.dashboardCardList$.subscribe((cards) => {
                    this.tracks = this.customDashboardsService.updateDashboardCardsTrack();
                    this.componentsOutletDirectiveService.detectViewChanges(this.cd);
                    this.componentsOutletDirectiveService.loadContents(this.dashboardOutlet);
                });
            });
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.customDashboardsService.reCreateExistingCharts();
    }

    applyNewFilters(event: string) {
        this.customDashboardsService.destroyCharts();
        this.hFilterJSON = event;
        this.action = NoDataActionType.filter;
        this.customDashboardsService.detectChange(
            this.hFilterJSON,
            this.displayOptions,
            true,
            false,
            this.action,
            this.dashboard
        );
    }

    applyDisplayOptions(event: DisplayOptions[]) {
        this.customDashboardsService.destroyCharts();
        this.displayOptions = event;
        this.action = NoDataActionType.filter;
        this.customDashboardsService.detectChange(
            this.hFilterJSON,
            this.displayOptions,
            false,
            true,
            this.action,
            this.dashboard
        );
    }

    dragWidget(event, i) {}

    ngOnDestroy() {
        this.customDashboardsService.unsubscribeFilters();
        this.customDashboardsService.destroyCharts();
    }
}
